import { Component, type ErrorInfo, type ReactNode } from "react";

type Props = { children: ReactNode };

type State = { error: Error | null };

export class MailAppErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error("[Mail] Erreur React au démarrage:", error, info.componentStack);
  }

  render() {
    if (this.state.error) {
      const detail = this.state.error.message?.trim() || String(this.state.error);
      return (
        <div
          style={{
            minHeight: "100dvh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "1.5rem",
            fontFamily: "Poppins, system-ui, sans-serif",
            background: "#f8f7fc",
            color: "#3f3d56",
          }}
        >
          <div style={{ maxWidth: "28rem", textAlign: "center" }}>
            <h1 style={{ fontSize: "1.1rem", marginBottom: "0.5rem" }}>Aurélia Mail</h1>
            <p style={{ margin: "0 0 0.75rem", fontSize: "0.9rem", opacity: 0.85 }}>
              Une erreur a interrompu l&apos;affichage. Rechargez après avoir déployé la dernière
              version, ou videz le cache PWA si le problème continue.
            </p>
            <pre
              style={{
                margin: "0 0 1rem",
                padding: "0.75rem",
                textAlign: "left",
                fontSize: "0.7rem",
                lineHeight: 1.35,
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
                borderRadius: "0.5rem",
                background: "#efeef6",
                color: "#5b5675",
              }}
            >
              {detail}
            </pre>
            <button
              type="button"
              style={{
                border: "none",
                borderRadius: "0.5rem",
                padding: "0.55rem 1rem",
                background: "#8b5cf6",
                color: "#fff",
                cursor: "pointer",
              }}
              onClick={() => window.location.reload()}
            >
              Recharger
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
